// extracted by mini-css-extract-plugin
export default {"arrow":"divkit-bf36b","arrow__icon":"divkit-a67bf","arrow_left":"divkit-e2a31","arrow_right":"divkit-c684b"};